import React, { useState } from 'react';
import { User, Bell, Lock, Globe, Shield } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Checkbox } from '../components/ui/Checkbox';
import { useAuth } from '../contexts/AuthContext';
export function SettingsPage() {
  const {
    user
  } = useAuth();
  const [activeTab, setActiveTab] = useState('profile');
  const tabs = [{
    id: 'profile',
    label: 'Profil',
    icon: User
  }, {
    id: 'notifications',
    label: 'Notifikasi',
    icon: Bell
  }, {
    id: 'security',
    label: 'Keamanan',
    icon: Lock
  }, {
    id: 'preferences',
    label: 'Preferensi',
    icon: Globe
  }];
  return <div className="min-h-screen bg-white" data-id="element-5120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-5121">
        <div className="mb-8" data-id="element-5122">
          <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-5123">
            Pengaturan
          </h1>
          <p className="text-neutral-600" data-id="element-5124">
            Kelola pengaturan akun dan preferensi Anda
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8" data-id="element-5125">
          {/* Sidebar */}
          <div className="lg:col-span-1" data-id="element-5126">
            <Card data-id="element-5127">
              <CardContent className="p-4" data-id="element-5128">
                <nav className="space-y-1" data-id="element-5129">
                  {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${activeTab === tab.id ? 'bg-atios-light text-atios-primary' : 'text-neutral-700 hover:bg-neutral-100'}`} data-id="element-5130">
                      <tab.icon className="w-4 h-4" data-id="element-5131" />
                      {tab.label}
                    </button>)}
                </nav>
              </CardContent>
            </Card>
          </div>

          {/* Content */}
          <div className="lg:col-span-3 space-y-6" data-id="element-5132">
            {activeTab === 'profile' && <>
                <Card data-id="element-5133">
                  <CardHeader data-id="element-5134">
                    <CardTitle data-id="element-5135">Informasi Pribadi</CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4" data-id="element-5136">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5137">
                      <Input label="Nama Lengkap" defaultValue={user?.nama} data-id="element-5138" />
                      <Input label="Email" type="email" defaultValue={user?.email} data-id="element-5139" />
                      <Input label="Nomor Telepon" type="tel" placeholder="+62812345678" defaultValue={user?.telepon} data-id="element-5140" />
                      <Input label="Tanggal Lahir" type="date" data-id="element-5141" />
                    </div>
                    <div data-id="element-5142">
                      <label className="text-sm font-medium text-neutral-900 block mb-2" data-id="element-5143">
                        Bio
                      </label>
                      <textarea className="flex min-h-[100px] w-full rounded-lg border border-neutral-300 bg-white px-4 py-3 text-sm text-neutral-900 placeholder:text-neutral-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atios-primary" placeholder="Ceritakan tentang diri Anda..." data-id="element-5144" />
                    </div>
                    <div className="flex justify-end gap-3 pt-4" data-id="element-5145">
                      <Button variant="secondary" data-id="element-5146">Batal</Button>
                      <Button data-id="element-5147">Simpan Perubahan</Button>
                    </div>
                  </CardContent>
                </Card>

                <Card data-id="element-5148">
                  <CardHeader data-id="element-5149">
                    <CardTitle data-id="element-5150">Foto Profil</CardTitle>
                  </CardHeader>
                  <CardContent data-id="element-5151">
                    <div className="flex items-center gap-6" data-id="element-5152">
                      <div className="h-20 w-20 rounded-full bg-atios-light border-2 border-atios-primary flex items-center justify-center text-atios-primary font-semibold text-2xl" data-id="element-5153">
                        {user?.avatar || 'U'}
                      </div>
                      <div className="flex-1" data-id="element-5154">
                        <Button variant="secondary" data-id="element-5155">Unggah Foto Baru</Button>
                        <p className="text-xs text-neutral-500 mt-2" data-id="element-5156">
                          JPG, PNG atau GIF. Maksimal 5MB.
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </>}

            {activeTab === 'notifications' && <Card data-id="element-5157">
                <CardHeader data-id="element-5158">
                  <CardTitle data-id="element-5159">Preferensi Notifikasi</CardTitle>
                </CardHeader>
                <CardContent className="space-y-6" data-id="element-5160">
                  <div data-id="element-5161">
                    <h3 className="text-sm font-semibold text-neutral-900 mb-3" data-id="element-5162">
                      Notifikasi Email
                    </h3>
                    <div className="space-y-3" data-id="element-5163">
                      <Checkbox label="Update dan pengingat acara" defaultChecked data-id="element-5164" />
                      <Checkbox label="Konfirmasi pembayaran" defaultChecked data-id="element-5165" />
                      <Checkbox label="Lowongan kerja baru" defaultChecked data-id="element-5166" />
                      <Checkbox label="Pengumuman chapter" data-id="element-5167" />
                      <Checkbox label="Newsletter dan update" data-id="element-5168" />
                    </div>
                  </div>

                  <div className="border-t border-neutral-200 pt-6" data-id="element-5169">
                    <h3 className="text-sm font-semibold text-neutral-900 mb-3" data-id="element-5170">
                      Notifikasi Push
                    </h3>
                    <div className="space-y-3" data-id="element-5171">
                      <Checkbox label="Pengingat acara" defaultChecked data-id="element-5172" />
                      <Checkbox label="Jatuh tempo pembayaran" defaultChecked data-id="element-5173" />
                      <Checkbox label="Pesan baru" data-id="element-5174" />
                    </div>
                  </div>

                  <div className="flex justify-end gap-3 pt-4" data-id="element-5175">
                    <Button variant="secondary" data-id="element-5176">Batal</Button>
                    <Button data-id="element-5177">Simpan Preferensi</Button>
                  </div>
                </CardContent>
              </Card>}

            {activeTab === 'security' && <>
                <Card data-id="element-5178">
                  <CardHeader data-id="element-5179">
                    <CardTitle data-id="element-5180">Ubah Kata Sandi</CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4" data-id="element-5181">
                    <Input label="Kata Sandi Saat Ini" type="password" data-id="element-5182" />
                    <Input label="Kata Sandi Baru" type="password" data-id="element-5183" />
                    <Input label="Konfirmasi Kata Sandi Baru" type="password" data-id="element-5184" />
                    <div className="flex justify-end gap-3 pt-4" data-id="element-5185">
                      <Button variant="secondary" data-id="element-5186">Batal</Button>
                      <Button data-id="element-5187">Perbarui Kata Sandi</Button>
                    </div>
                  </CardContent>
                </Card>

                <Card data-id="element-5188">
                  <CardHeader data-id="element-5189">
                    <CardTitle data-id="element-5190">Autentikasi Dua Faktor</CardTitle>
                  </CardHeader>
                  <CardContent data-id="element-5191">
                    <div className="flex items-start gap-4" data-id="element-5192">
                      <Shield className="w-5 h-5 text-atios-primary mt-1" data-id="element-5193" />
                      <div className="flex-1" data-id="element-5194">
                        <p className="text-sm text-neutral-700 mb-4" data-id="element-5195">
                          Tambahkan lapisan keamanan ekstra ke akun Anda dengan
                          mengaktifkan autentikasi dua faktor.
                        </p>
                        <Button variant="secondary" data-id="element-5196">Aktifkan 2FA</Button>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </>}

            {activeTab === 'preferences' && <Card data-id="element-5197">
                <CardHeader data-id="element-5198">
                  <CardTitle data-id="element-5199">Preferensi</CardTitle>
                </CardHeader>
                <CardContent className="space-y-6" data-id="element-5200">
                  <div data-id="element-5201">
                    <label className="text-sm font-medium text-neutral-900 block mb-2" data-id="element-5202">
                      Bahasa
                    </label>
                    <select className="flex h-9 w-full rounded-lg border border-neutral-300 bg-white px-4 py-2 text-sm text-neutral-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atios-primary" data-id="element-5203">
                      <option value="id" data-id="element-5204">Bahasa Indonesia</option>
                      <option value="en" data-id="element-5205">English</option>
                    </select>
                  </div>

                  <div data-id="element-5206">
                    <label className="text-sm font-medium text-neutral-900 block mb-2" data-id="element-5207">
                      Zona Waktu
                    </label>
                    <select className="flex h-9 w-full rounded-lg border border-neutral-300 bg-white px-4 py-2 text-sm text-neutral-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atios-primary" data-id="element-5208">
                      <option value="asia/jakarta" data-id="element-5209">Asia/Jakarta (WIB)</option>
                      <option value="asia/makassar" data-id="element-5210">
                        Asia/Makassar (WITA)
                      </option>
                      <option value="asia/jayapura" data-id="element-5211">Asia/Jayapura (WIT)</option>
                    </select>
                  </div>

                  <div data-id="element-5212">
                    <label className="text-sm font-medium text-neutral-900 block mb-2" data-id="element-5213">
                      Format Tanggal
                    </label>
                    <select className="flex h-9 w-full rounded-lg border border-neutral-300 bg-white px-4 py-2 text-sm text-neutral-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atios-primary" data-id="element-5214">
                      <option value="dd/mm/yyyy" data-id="element-5215">DD/MM/YYYY</option>
                      <option value="mm/dd/yyyy" data-id="element-5216">MM/DD/YYYY</option>
                      <option value="yyyy-mm-dd" data-id="element-5217">YYYY-MM-DD</option>
                    </select>
                  </div>

                  <div className="flex justify-end gap-3 pt-4" data-id="element-5218">
                    <Button variant="secondary" data-id="element-5219">Batal</Button>
                    <Button data-id="element-5220">Simpan Preferensi</Button>
                  </div>
                </CardContent>
              </Card>}
          </div>
        </div>
      </div>
    </div>;
}